import { IAsset } from "../../../../../types/file-attachment.interface";

import { FileLink } from "./file-link.component";

export const renderFileLink = (asset: IAsset, canDownload: boolean) => (
  <FileLink asset={asset} canDownload={canDownload} />
);
